module.exports = __webpack_public_path__ + "static/media/Select-FIre Rapidstrike Kit 1.4e3c6bab.jpg";